module.exports = __webpack_public_path__ + "static/media/Driver.a42ac3af.png";